// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"LoginControl_mainDiv__SELpf"};